export const qualityLabel = (videoTrack): string => {
  const shorterSide = Math.min(videoTrack.width, videoTrack.height);

  return (
    shorterSide +
    (shorterSide >= 2160 ? "p UHD" : shorterSide >= 720 ? "p HD" : "p")
  );
};

// Filter out "audio only" track (no height) and redundant quality levels with the same height and bitrate
const filterQualityLevels = videoTracks =>
  videoTracks.filter(
    (level, index, arr) =>
      level.height &&
      arr.findIndex(
        l => l.height === level.height && l.bitrate === level.bitrate
      ) === index
  );

const qualityLevelMapper = (qualityLevel, levels, index, keyword) => {
  const otherLevelsWithSameHeight = levels.filter(
    level => level !== qualityLevel && level.height === qualityLevel.height
  );

  const othersHighestBitrate = otherLevelsWithSameHeight.reduce(
    (previousValue, currentValue) =>
      currentValue[keyword] > previousValue
        ? currentValue[keyword]
        : previousValue,
    0
  );

  return {
    bitrate: qualityLevel[keyword],
    hidden: qualityLevel[keyword] < othersHighestBitrate,
    index,
    label: qualityLabel(qualityLevel)
  };
};

export const mapPlayerVideoTracks = videoTracks =>
  filterQualityLevels(videoTracks)
    .map((qualityLevel, index) =>
      qualityLevelMapper(qualityLevel, videoTracks, index, "bitrate")
    )
    .sort((a, b) => b.bitrate - a.bitrate)
    .map((track, index, arr) => {
      track.hidden =
        track.hidden ||
        (track.label === arr[index - 1]?.label &&
          track.bitrate === arr[index - 1]?.bitrate);
      return track;
    })
    .sort((a, b) => parseInt(b.label) - parseInt(a.label));
